var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:{
      'f-modal': true,
      'is-big': _vm.isBig
    }},[_c('div',{staticClass:"f-modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"f-modal-content card"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }